"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "logo", {
  enumerable: true,
  get: function () {
    return _logo.default;
  }
});
var _logo = _interopRequireDefault(require("./logo.svg"));